import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateTeacherTeachingBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const updateTeacherTeaching = createAsyncThunk<void, UpdateTeacherTeachingBody, { extra: Partial<Dependencies> }>(
  "teachers/updateTeacherTeaching",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.updateTeaching(body);
  },
);

export const resetUpdateTeacherTeaching = createAction("teachers/resetUpdateTeacherTeaching");
